(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultCriticalDialogController', PatientResultCriticalDialogController);

    PatientResultCriticalDialogController.$inject = ['$uibModalInstance', 'result', 'PatientResultDet'];

    function PatientResultCriticalDialogController($uibModalInstance, result, PatientResultDet) {
        var vm = this;

        vm.criticalResult = result;
        vm.comments = PatientResultDet.getComments({id: result.id});
        vm.testResult =  result.result + ' (' + result.status + ')';
        vm.acknowledgeBy = result.name + ' ' + result.lastName;

        vm.clear = clear;
        vm.acknowledge = acknowledge;

        PatientResultDet.getEmployeeComments({id: result.id}, function (comments) {
            vm.prDetEmployeeComments = comments;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function acknowledge() {
            PatientResultDet.acknowledge({ids: [result.id]}, function () {
                $uibModalInstance.close('success')
            })
        }
    }
})();
